export const responsesTokenExpired = ['Unauthorized', 'The incoming token has expired'];
